module.exports = __webpack_public_path__ + "img/1.1984a571.png";